/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/clusters': {
    width: 21,
    height: 24,
    viewBox: '0 0 21 24',
    data: '<g _fill="#000" fill-rule="evenodd"><path pid="0" d="M15 3a1 1 0 011 1v11.511a1 1 0 01-1 1h-3V7.133a2 2 0 00-1.85-1.994L10 5.133H8V4a1 1 0 011-1h6z"/><rect pid="1" y="7.111" width="10" height="16.889" rx="1"/><path pid="2" d="M20 0a1 1 0 011 1v8.133a1 1 0 01-1 1l-2.04.001c.026-.13.04-.263.04-.4V3.6a2 2 0 00-2-2h-1V1a1 1 0 011-1h4z"/></g>'
  }
})
